import { GUI } from 'lil-gui'
import { DirectionalLight } from 'three';
import { MyGUI } from './MyGUI';
import { Random } from './Random';

export class Params {

    public static gui:GUI;
    //public static 
    public static canvasWidth:number = 512;
    public static canvasHeight:number = 512;
    
    public static width:number = 512;
    public static height:number = 512;
    public static wire:THREE.Mesh;
    public static dLight:DirectionalLight;

    public static colorId:number = 0;
    public static colorMax:number = 8;
    public static sizeId:number = 0;
    public static spaceId:number = 0;
    public static resolutionId:number = 0;
    public static divisionId:number = 0;
    public static isPreviewed:boolean=false;

    public static duration:number=3;
    public static resolution:number = 512;
    public static interval:number = 10;//sec
    
    public static p5element:HTMLElement;

    public static numRules:number=0;
    public static rules:number[];

    public static init(){

        MyGUI.Init();
        this.gui = MyGUI.gui;

        //解像度
        Params.setResolution();
        Params.setDivision();
        Params.setRule();

        Params.setFxParams();

        document.addEventListener('keydown', (event) => {
            const keyName = event.key;
            if(keyName=="s"){
                Params.download();
            }
        });        
    }

    //解像度を決める、今回は固定
    public static setResolution(){
        Params.resolutionId = 0;
        Params.resolution = 512;
    }

    //ルールを決める
    public static setRule(){
        let baseRules:number[] = [];
        for(let i=0;i<256;i++){
            baseRules[i]=i;
        }

        Params.rules = [];
        let numRandom=16;


        let rr = Random.value;
        if(rr<0.333){
            numRandom=5;
        }else if(rr<0.666){
            numRandom=10;
        }else{
            numRandom=15;
        }

        if(Params.divisionId==2){
            let rr = Random.value;
            if(rr<0.75){
                numRandom=3;
            }else{
                numRandom=15;
            }

        }

        for(let i=0;i<numRandom;i++){
            let rr = baseRules.splice(
                Math.floor(Random.value*baseRules.length),
                1
            );
            Params.rules.push(rr[0]);
        }
    }

    public static setDivision(){

        let rr = Random.value;
        if(rr<0.5){
            Params.divisionId=0;
        }else if(rr<0.8){
            Params.divisionId=1;
        }else{
            Params.divisionId=2;
        }

        
    }

    public static setFxParams(){

        //ルール数
        let fxObj:any = {};
        for(let i=0;i<Params.rules.length;i++){
            let label = "rule"+Params.zeroPadding(Params.rules[i],3); 
            console.log(i,label);
            fxObj[label] = Params.zeroPadding(Params.convertToBinary(Params.rules[i]),8); 
        }
        //fxObj.color     = Params.colorId;
        fxObj.divisionType  = Params.divisionId;
        
        console.log("------param------")
        console.log(fxObj);

        (window as any).$fxhashFeatures = fxObj;
        
        //guiに表示
        //let a =Params.gui.addFolder("features");
        //a.add(Params,"colorId");
        //a.add(Params,"sizeId");
        //a.add(Params,"resolutionId");
        //a.add(Params,"resolution");
        //a.add(Params,"divisionId");
        //a.add(Params,"download")

    }

    public static download(){

        let dom = document.getElementById("webgl") as HTMLCanvasElement;
        let link = document.createElement('a')
        link.href = dom.toDataURL('image/png')

        const d1 = new Date();
      
        let yy = Params.zeroPadding(d1.getFullYear()%100,2);
        let mo = Params.zeroPadding(d1.getMonth()+1,2);
        let dd = Params.zeroPadding(d1.getDate(),2);    
      
        let hh = Params.zeroPadding(d1.getHours(),2);
        let mm = Params.zeroPadding(d1.getMinutes(),2);
        let ss = Params.zeroPadding(d1.getSeconds(),2);
        
        link.download = yy+mo+dd+"_"+hh+mm+ss+'.png'
        link.click()

    }

    public static preview(){
        if(Params.isPreviewed)return;

        let hoge = window as any;
        if(hoge.fxpreview!=null){
            Params.isPreviewed=true;
            console.log('%cPREVIEW', 'color: red');
            return hoge.fxpreview();
        }
    }

    public static convertToBinary(x:number):number {

        let bin = 0;
        let rem, i = 1, step = 1;
        while (x != 0) {
            rem = x % 2;
            x = Math.floor(x / 2);
            bin = bin + rem * i;
            i = i * 10;
        }
        //console.log(`Binary: ${bin}`);
        return bin;
    }

    public static zeroPadding(NUM:number, LEN:number):string{
        
        return String(NUM).padStart(LEN, '0');

        //return ( Array(LEN).join('0') + NUM ).slice( -LEN );
    }

}